<mat-dialog-content>
  <form [formGroup]="form" (submit)="handleSubmit()">
    <span>Enter 6-digit authentication code seen on Google Authenticator application.</span>
    <ng-otp-input formControlName="code" [config]="{ length: 6 }"></ng-otp-input>
    <button type="submit" class="btn-submit">Verify and Enable 2FA</button>
  </form>
</mat-dialog-content>
